import React, { useEffect, useRef, useState } from 'react';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { faSpinner } from '@fortawesome/free-solid-svg-icons';
import SideNav from './Partials/SideNav';
import { qprService } from '../../../../Services';
import { qprActions } from '../../../../Actions';
import { useDispatch, useSelector } from 'react-redux';
import { useLocation } from 'react-router-dom';
import ReactTooltip from 'react-tooltip';

const ResponseToTEForm = () => {
  const location = useLocation();
  const { qpr_id, qh } = location.state;
  const qpr = useSelector((state) => state.qpr_data);
  const dispatch = useDispatch();

  const [submitted, setSubmitted] = useState(false);
  const [drafted, setDrafted] = useState(false);
  const [mqcif, setMqcif] = useState(qpr.response_to_te? qpr.response_to_te.mqcif: "");

  const [input, setInput] = useState(qpr.response_to_te && qpr.response_to_te.rtte && qpr.response_to_te.rtte.length > 0? qpr.response_to_te.rtte: [{
    fellow_response: '',
  }]);

  useEffect( () => {
    if(typeof qpr.response_to_te == "undefined") {
      qprService.responseToTE(qpr_id).then(rslt => {
        qpr.response_to_te = rslt.data.response_to_te;
        qpr.form_validation = JSON.parse(rslt.data.response_to_te.form_validation);
        localStorage.setItem("qpr_data", JSON.stringify(qpr));
        dispatch(qprActions.qprData(qpr));
        setInput(qpr.response_to_te.rtte);
        setMqcif(qpr.response_to_te.mqcif);
      });
    }
  }, []);

  const [validationError, setValidationError] = useState([{fellow_response: null, mqcif: ""}]);
  const ref = useRef([]);

  const handleChange = (index, e) => {
    const { name, value } = e.target;
    const list = [...input];
    list[index][name] = value;
    setInput(list);
  }

  const checkValidation = () => {
    let error = {};
    Object.keys(input).map(item => {
      if(input[item] == "" && item != "user_status") {
        error[item] = "Required";
      }
    });

    if(Object.keys(error).length>0) {
      setValidationError(error);
      const ref_focus_key = Object.keys(error)[0];
      ref.current[ref_focus_key].focus();
    }
    return error;
  }

  const submitForm = (submit_status, fnctn) => {
    setValidationError({});
    let input_data = {response: input};
    qpr.form_validation.response_to_te.submit_status = 0;
    input_data.mqcif = mqcif;
    input_data.submit_status = 0;
    if(submit_status == 1) {
      qpr.form_validation.response_to_te.submit_status = 1;
      input_data.submit_status = 1;
      if(Object.keys(checkValidation()).length > 0) {
        fnctn(false);
        return false;
      }
    }
    input_data.form_validation = JSON.stringify(qpr.form_validation);
    qprService.responseToTESave(input_data, qpr_id).then(res => {
      qpr.response_to_te = res.data.response_to_te;
      localStorage.setItem("qpr_data", JSON.stringify(qpr));
      dispatch(qprActions.qprData(qpr));
      fnctn(false);
    });
  }

  const handleSubmit = (e) => {
    e.preventDefault();
    let submit_status = e.target.dataset.submit_status;
    let fnctn = submit_status==1? setSubmitted: setDrafted;
    fnctn(true);
    submitForm(submit_status, fnctn);
  }
  
  return (
    <>
      <section className="pt-4 pb-50 content-min-height">
        <div className="container">
          <div className="row">
            <div className="col-lg-12">
              <div className="section-title">
                <h5>{qh}</h5>
              </div>
              <div className='row mt-4'>
                <div className='col-md-4'>
                  <SideNav />
                </div>
                <div className='col-md-8'>
                  <div className='card border-info' style={{"borderTop": "3px solid"}}>
                    <div className='card-header'><h6>Response To Comments By Technical Experts From Previous Quarterly Progress Review</h6></div>
                    <div className="contact-from pt-0">
                      <div className="main-form">
                        <form onSubmit={handleSubmit} data-submit_status={1}>
                          <div className='singel-form' id='field-container'>
                            {input.map((data, index) => {
                              return (<div className="row" key={index}>
                                <div className='col-md-12'>
                                  <strong>{data.full_name}: </strong>
                                  {data.recommendation}
                                </div>
                                <div className='col-md-12' >
                                  <textarea name='fellow_response' value={data.fellow_response} onChange={e => handleChange(index, e)} data-error="Response is required"></textarea>
                                  {/* {validationError[index].fellow_response && <span className='text-danger'>{validationError[index].fellow_response}</span>} */}
                                </div>
                                <div className='col-md-12'><hr/></div>
                              </div>)
                            })}
                          </div>
                          <div className="singel-form1">
                            <label >Mid-Quarterly Check-In Facilitated<span className='text-danger'>*</span>:&nbsp;</label>
                            <div className="form-check-inline">
                              <label className="form-check-label">
                              <input type="radio" className="form-check-input" name="mqcif" value="Yes" checked={mqcif === "Yes"} ref={r => {ref.current['mqcif'] = r}} onChange={() => setMqcif("Yes")} />Yes
                              </label>
                            </div>
                            <div className="form-check-inline">
                              <label className="form-check-label">
                                <input type="radio" className="form-check-input" name="mqcif" value="No" checked={mqcif === "No"} ref={r => {ref.current['mqcif'] = r}} onChange={() => setMqcif("No")} />No
                              </label>
                            </div>
                            {validationError.mqcif && <span className='text-danger'>{validationError.mqcif}</span>}
                          </div>
                          <hr/>
                          <div className="singel-form">
                            <button type="button" className="main-btn btn-info btn-outline-info disabled" onClick={submitted? '': handleSubmit} data-tip data-for="draft">
                              {drafted ? <span><FontAwesomeIcon icon={faSpinner} className="fa-spin" /> Please wait</span> : <span>Draft</span>}
                            </button>
                            <ReactTooltip id="draft" place="top" effect="solid">
                              You can save the form as draft if you do not have all the required information to fill
                            </ReactTooltip>
                            <button type={submitted? "button": "submit"} className="main-btn btn-info ml-3 disabled">
                              {submitted ? <span><FontAwesomeIcon icon={faSpinner} className="fa-spin" /> Please wait</span> : <span>Save</span>}
                            </button>
                          </div>
                        </form>
                      </div>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </section>
    </>
  );
};

export default ResponseToTEForm;